// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ChevronUp: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
            <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.05"
                d="m2.308 7.795 3.517-3.517a.246.246 0 0 1 .348 0s0 0 0 0L9.69 7.795"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const ChevronUpOffset: IconOffset = {
    vertical: 29, // Store Custom Code
    horizontal: 13, // Store Custom Code
};

export default React.memo(ChevronUp);
